import get from './methodGet';
import post from './methodPost';

export default {
  ...get,
  ...post
};
